import { DSolutionsBadgeData } from '@bm-js/atlascloud-shared'
import { ContentType } from '@bm-js/atlascloud-shared'
import { isEditor } from '../utils/misc'
import { useMargin } from '../utils/hooks'

type Props = {
  content: ContentType<DSolutionsBadgeData>
}

export const DSolutionBadgeContent = ({ content }: Props) => {
  const margins = useMargin(content)
  const linkProps = isEditor()
    ? {}
    : {
        href: 'https://dsolution.se/',
        target: '_blank',
        rel: 'noopener noreferrer',
      }
  return (
    <div className={`flex justify-center ${margins}`}>
      <a {...linkProps}>
        <img
          src='https://dsolution.se/wp-content/uploads/2025/01/certbild-dsolution-svart.webp'
          alt='DSolution Certified'
        />
      </a>
    </div>
  )
}
